<script setup lang="ts">
import { useField } from 'vee-validate'
import { useElementalForm } from '../../ElementalFormContextProvider/context'
import { useAutosave } from '../../FormAutomaticSave/context'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import Avatar from '@/components/Elemental/Avatar/index.vue'
import FormInput from '@/components/Form/Input/index.vue'

const props = withDefaults(defineProps<{
  name: string
  placeholder?: string
  hiddeIcon?: boolean
}>(), {
  placeholder: 'Add title',
})

const { elemental, elementalType, disabled, isSidebarView } = useElementalForm()
const [query] = useQueryParams('sbarr_f', 'field')

const { value, errorMessage } = useField<string>(props.name)
const listenerCancel = ref<(() => void) | null>(null)

const { onValueChange, addFieldListener } = useAutosave()
const handlerBlur = (newValue: string) => {
  if (newValue !== value.value) {
    onValueChange(props.name, `${newValue}`)
    value.value = newValue
  }
}

onMounted(() => {
  listenerCancel.value = addFieldListener(props.name, (newValue: string) => {
    onValueChange(props.name, `${newValue}`)
    value.value = newValue
  })
})

const inputRef = ref<InstanceType<typeof FormInput> | null>(null)
watch(() => elemental.value?.id, () => {
  if (query.value === props.name && isSidebarView?.value)
    inputRef.value?.focus()
})

onUnmounted(() => {
  if (listenerCancel.value)
    listenerCancel.value()
})

const handleInputBlur = (event: Event) => {
  const target = event.target as HTMLInputElement
  handlerBlur(target?.value)
}
</script>

<template>
  <div class="flex-grow w-full">
    <FormInput
      :id="name"
      ref="inputRef"
      :value="value"
      :name="name"
      :disabled="disabled"
      :error="errorMessage"
      :placeholder="placeholder"
      class="!bg-transparent border-none px-0!"
      input-class="text-[20px] leading-[24px] h-11 font-bold color-soft-black border-1 border-transparent transition-colors   hover:border-darkGray focus-within:border-darkGray placeholder:transition-colors  !placeholder:text-soft-black rounded px-2"
      @blur="handleInputBlur"
    >
      <template #prefix>
        <slot name="icon">
          <div class="flex flex-shrink-0 center pl-2">
            <Avatar v-if="!hiddeIcon" :elemental="elemental" :type="elementalType?.id ?? ElementalTypeEnum.List" icon-class="m-auto" />
          </div>
        </slot>
      </template>
    </FormInput>
  </div>
</template>
